export default __webpack_public_path__ + "static/media/Resume_Eliran_Niderhofer.bee0aeb4.pdf";